<template>
  <div class="wrapper">
    <h1 class="banner-title">{{ $t('home.design.header.description') }}</h1>
    <h2 class="subtitle">{{ $t('home.design.header.title') }}</h2>
    <BannerSearch />
    <div v-if="showSuggestions" class="banner-try-searching">
      <span>{{ $t('home.design.mainSearch.title') }}</span>
      <nuxt-link
        v-for="(s, i) in suggestedSearches"
        :key="i"
        class="suggestion"
        :to="
          $urlBuilder('search', {
            path: s.path,
            keyword: s.keyword
          })
        "
      >
        <span>{{ s.text }}</span
        ><span class="comma">, </span>
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import BannerSearch from '../BannerSearch';

export default {
  name: 'DesignContentBanner',
  components: {
    BannerSearch
  },
  props: {
    suggestedSearches: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showSuggestions() {
      return this.suggestedSearches && this.suggestedSearches.length > 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  color: #474747;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.banner-title {
  font-size: 34px;
  font-weight: 500;
  text-align: center;
  line-height: 1.5;
  margin-bottom: 5px;
  @include xl2 {
    font-size: 26px;
  }
  @include lg {
    font-size: 20px;
    width: 70%;
  }
  @include md {
    width: 80%;
  }
  @include sm {
    width: 90%;
    font-size: 16px;
  }
}
.subtitle {
  font-size: 16px;
  margin-top: 8px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 5px;

  @include xl2 {
    margin-bottom: 30px;
    font-size: 14px;
  }
  @include xl {
    margin-bottom: 24px;
    font-size: 12px;
  }
  @include lg {
    margin-top: 24px;
    font-size: 10px;
  }
  @include sm {
    margin-top: 12px;
    font-size: 8px;
  }
}
.banner-try-searching {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 12px;
  user-select: auto;
  margin-top: 20px;
  z-index: 100;
  @include xl2 {
    margin-top: 10px;
  }
  @include md {
    font-size: 9px;
    margin-top: 14px;
  }
  .suggestion {
    color: $defaultColor;
    margin-left: 2px;
  }
  .suggestion:last-child .comma {
    display: none;
  }
}
</style>
